import { ChapterDto } from './chapter.model';
import { Chapter } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapChapter(chapterDto: ChapterDto, bookId: string): Chapter {
  return {
    id: chapterDto.id,
    name: chapterDto.name,
    position: chapterDto.position,
    prefix: chapterDto.prefix,
    totalParagraphs: chapterDto.paragraphs.length,
    bookId,
  };
}
